import React, { Component } from "react";
import Logo from "../assets/img/LogoMakr-4Km0B6.png";

import "./Posts.css";

export default class Posts extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="wonym">
          <div className="input d-flex">
            <img src={Logo} className="user-profile-img mr-2" />
            <div className="w-100">
              <input
                className="form-control wonym-input"
                placeholder="What's on your mind?"
              />
              <hr />
            </div>
          </div>
          <div className="reaction-btn d-flex w-100">
            <div className="w-75">
              <i className="far fa-grin fa-lg"></i>
              <i className="far fa-file-image fa-lg ml-2"></i>
              <i className="fa fa-external-link-alt fa-lg ml-2"></i>
            </div>
            <button className="btn-beautyhand w-25">Post</button>
          </div>
        </div>
        <hr />
        <div className="post">
          <div className="post-head">
            <div className="post-user-details">
              <img src={Logo} className="user-profile-img" />
              <p>Biruk Erjamo</p>
            </div>
            <div className="post-date">
              <i className="fa fa-globe"></i>
              <p className="pl-2">November 18 at 12:10 PM</p>
            </div>
          </div>
          <div className="post-body">
            <p>Hello Everyone</p>
          </div>
          <div className="post-foot">
            <center>
              <div className="row justify-content-center">
                <div className="col-md-4 reaction">
                  <i className="far fa-comment-alt fa-lg" />
                </div>
                <div className="col-md-4 reaction-ad">
                  <i className="fa fa-heart fa-lg" />
                </div>
                <div className="col-md-4 reaction">
                  <i className="fa fa-share-alt fa-lg" />
                </div>
              </div>
            </center>
          </div>
        </div>
        <div className="post mt-5">
          <div className="post-head">
            <div className="post-user-details">
              <img src={Logo} className="user-profile-img" />
              <p>Yishak Abrham</p>
            </div>
            <div className="post-date">
              <i className="fa fa-globe"></i>
              <p className="pl-2">November 18 at 12:10 PM</p>
            </div>
          </div>
          <div className="post-body">
            <img
              src="https://randomwordgenerator.com/img/picture-generator/57e9d14a494faa0df7c5d57bc32f3e7b1d3ac3e45659784a712d7bd296_640.jpg"
              className="post-img"
            />
          </div>
          <div className="post-foot">
            <center>
              <div className="row justify-content-center">
                <div className="col-md-4 reaction">
                  <i className="far fa-comment-alt fa-lg" />
                </div>
                <div className="col-md-4 reaction-ad">
                  <i className="fa fa-heart fa-lg" />
                </div>
                <div className="col-md-4 reaction">
                  <i className="fa fa-share-alt fa-lg" />
                </div>
              </div>
            </center>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
